import type theme from '#build/ui/slideover'
import type { DeepPartial } from '@nuxt/ui'

const slideover: DeepPartial<typeof theme> = {
  slots: {
    header: 'card-shadow bg-white border-0 relative z-10',
    content: ' bg-white sm:shadow-lg sm:ring-1',
  },
}

export default slideover
